import { TranslationDict } from "../types";

export const nlOpbouw: TranslationDict = {
  woning: "Woning",
  ruimtes: "Ruimtes",
  uitgangen: "Uitgangen",
  ingangen: "Ingangen",
  aantal: "Aantal",
  ruimte: "Ruimte",
  uitgang: "Uitgang",
  maakNaamLeeg: "Maak naam leeg",
  geefNaamRuimte: "Geef een naam voor de ruimte:",
  voegRuimteToe: "Voeg ruimte toe",
  geenRuimteGekozen: "Geen ruimte gekozen.",
  moduleBestaatNiet: "Deze module bestaat niet.",
  kast: "Kast",
  kasten: "Kasten",
  voegKastToe: "Voeg kast toe",
  naamKast: "Naam van kast:",
  naamCtd: "Naam van de controller:",
  naamCtdTip: "Neem best een unieke naam om verwarring tussen CTDs te vermijden.",
  controllers: "Controllers",
  voegCtdToe: "Voeg CTD toe",
  offerte: "Offerte",
  saOfferte: "SA Offerte",
  info: "Info",
  indienst: "Indienst",
  voegIndienstToe: "Voeg indienst toe",
  totaalprijs: "Totaalprijs",
  module: "Module",
  prijs: "Prijs",
  totaal: "Totaal",
  vrije: "Vrije",
  nietInSa: "Onderstaande modules hebben we niet in Stand Alone uitvoering:",
  dmx1: "Dimmer",
  dmx6: "RGB",
  dmx8: "RGBW",
  dmx4: "WwKw",
  qdmAddressType: "Type adres",
  qdmIndividual: "Individueel adres",
  qdmGroup: "Groepsadres",
  qdmFixtureCount: "Aantal armaturen in groep",
  aantalMods: "Aantal modules",
  aantalAdressen: "Aantal adressen",
  busconsumtion: "Bus consumptie",
  typeUitvoering: "Type afwerking",
  errorOffSave: "Om een offerte te kunnen genereren moet uw project eerst bewaard worden.",
  errFullSa: "Gelieve FullOfferte of SaOfferte te kiezen..",
  errGenOff: "Er is een fout opgetreden bij het genereren van de offerte.",
  errGenOverview: "Om een overzicht te kunnen genereren moet uw project eerst bewaard worden.",
};
